// extracted by mini-css-extract-plugin
export default {"publish-button-wrapper":"Document_publish-button-wrapper__zzCfB","document-not-found":"Document_document-not-found__E4WBs"};